//enum со значениями stage.step, используется в логике вместо magic numbers
export const globals = {
  STEP_SOGLAS: 1,
  STEP_SBORKA: 2,
  STEP_PECHAT: 3,
  STEP_KOTGRUZKE: 4,
  STEP_DOSTAVKA: 5,
  STEP_OTGRUZENY: 6,
  STEP_DOPRABOTY: 7,
  STEP_OTMENA: 8,
  STEP_ZAKRIT: 9,
}